import ContentRoutes from 'ContentUtils/Routes';
import { AudienceAccessTypeToAccessControl } from 'ui-memberships-settings-lib/constants/AccessControlTypes';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, contentIsPublished } from 'content-management-data-lib';
import { AudienceAccessTypes } from 'ui-memberships-settings-lib/constants/AudienceAccessTypes';
export function contentIsDeleted(contentObject) {
  const deletedAt = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ARCHIVED_AT);
  return deletedAt ? deletedAt > 0 : false;
}
export function getContentAccessControlType(contentObject) {
  const audienceAccessType = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS) || AudienceAccessTypes.PUBLIC;
  return AudienceAccessTypeToAccessControl[audienceAccessType];
}
export const getPreviewImageURL = content => {
  const isDeleted = contentIsDeleted(content);
  if (isDeleted) {
    return '';
  }
  const isPublished = contentIsPublished(content);
  const previewKey = getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.PREVIEW_KEY);
  if (!previewKey || isPublished) {
    return getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL);
  }
  return ContentRoutes.getPreviewUrl(content.objectId, {
    cacheBust: null,
    from_buffer: false,
    preview_key: previewKey
  });
};
export function getScreenshotPreviewUrl(content) {
  const screenshotPreviewUrl = getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.SCREENSHOT_PREVIEW_URL);
  const screenshotPreviewTakenAt = getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.SCREENSHOT_PREVIEW_TAKEN_AT);
  const updated = getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT);
  return screenshotPreviewUrl && screenshotPreviewTakenAt && screenshotPreviewTakenAt >= updated ? screenshotPreviewUrl : '';
}
export function getContentLayoutId(content) {
  const parentBlog = getContentPropertyValue(content, CONTENT_PLATFORM_PROPERTY_NAME.PARENT_BLOG);
  if (!parentBlog) {
    return undefined;
  }
  const {
    itemLayoutId,
    listingLayoutId
  } = parentBlog;
  if (itemLayoutId) {
    return parseInt(itemLayoutId, 10);
  } else if (listingLayoutId) {
    return parseInt(listingLayoutId, 10);
  }
  return undefined;
}
export function getAnalyticsPageId(contentObject) {
  const analyticsId = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ANALYTICS_PAGE_ID);
  return analyticsId;
}
export default getAnalyticsPageId;